
import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const vibeCodingTableOfContents: TableOfContentsItem[] = [
  {
    id: "que-es-vibe-coding",
    title: "Qué es exactamente el vibe coding",
    subItems: [
      { id: "origen", title: "Origen del término" },
      { id: "diferencia-nocode", title: "Diferencia con el no-code tradicional" }
    ]
  },
  {
    id: "por-que-2026",
    title: "Por qué 2026 es el año clave",
    subItems: [
      { id: "modelos-ia", title: "Evolución de los modelos de IA" },
      { id: "coste-producto", title: "Caída del coste de lanzamiento" }
    ]
  },
  {
    id: "herramientas",
    title: "Las herramientas que lideran el movimiento",
    subItems: [
      { id: "lovable", title: "Lovable" },
      { id: "bolt-cursor-v0", title: "Bolt, Cursor y v0" }
    ]
  },
  {
    id: "vibe-coding-seo",
    title: "Vibe coding y SEO",
    subItems: [
      { id: "activos-posicionables", title: "Activos digitales posicionables" },
      { id: "oportunidad-seo", title: "La oportunidad que pocos aprovechan" }
    ]
  },
  {
    id: "ejemplo-real",
    title: "De idea a MVP en 8 semanas",
    subItems: [
      { id: "proceso-semanas", title: "Proceso semana a semana" }
    ]
  },
  {
    id: "limitaciones",
    title: "Lo que el vibe coding no resuelve",
    subItems: [
      { id: "criterio-negocio", title: "Criterio de negocio" },
      { id: "escalabilidad", title: "Escalabilidad y mantenimiento" }
    ]
  },
  {
    id: "conclusion",
    title: "El vibe coding como palanca de negocio"
  }
];
